import { getTags } from "../api/tags.js";
import { SwApiStore } from "./sw-api-store.js";

export const tagsStore = SwApiStore({
  get: getTags,
  init: () => [],
});
